var App = App || {};

App = (() => {
    "use strict";
    // Initialize the application
    const init = () => {
        // Handle smooth scrolling for anchor links
        document.querySelectorAll('a[href^="#"]:not(.skipto, #sbModalSubmit)')
            .forEach(link => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    const href = link.getAttribute('href');
                    if (href !== '#' && link.getAttribute('role') !== 'tab') {
                        scrollTo(document.querySelector(href));
                    }
                });
            });

        // Initialize animations
        onScrollInit(document.querySelectorAll('.os-animation'));

        // Handle staggered animations
        document.querySelectorAll('.staggered-animation').forEach(element => {
            onScrollInit(new Array(element), element.closest('.staggered-animation-container'));
        });
    };

    // Add overlay element
    const addOverlay = () => {
        if (!document.body.querySelector('.overlay')) {
            const overlay = document.createElement('div');
            overlay.className = 'overlay fade';
            document.body.prepend(overlay);
            overlay.classList.add('show');
        }
    };

    // Remove overlay element
    const removeOverlay = () => {
        document.body.querySelector('.overlay')?.remove();
    };

    // Initialize scroll-based animations
    const onScrollInit = (items, trigger) => {
        items.forEach(element => {
            const animationClass = element.dataset.osAnimation;
            const animationDelay = element.dataset.osAnimationDelay;

            // Apply animation delay
            element.style.animationDelay = animationDelay;

            const animationTrigger = trigger || element;

            // Using IntersectionObserver instead of Waypoint
            const observer = new IntersectionObserver(([entry]) => {
                if (entry.isIntersecting) {
                    element.addEventListener('animationend', () => {
                        element.classList.add('animation-complete');
                        element.classList.remove('animate__animated');
                        observer.disconnect();
                    }, { once: true });

                    element.classList.add('animate__animated', animationClass);
                }
            }, {
                threshold: 0.10,
                rootMargin: '0px'
            });

            observer.observe(animationTrigger);
        });
    };

    // Announce text for screen readers
    const speak = (text, priority = 'polite') => {
        const id = `speak-${Date.now()}`;
        const element = document.createElement('div');
        element.id = id;
        element.setAttribute('aria-live', priority);
        element.classList.add('sr-only');
        document.body.appendChild(element);

        setTimeout(() => {
            element.textContent = text;
        }, 100);

        setTimeout(() => {
            element.remove();
        }, 1000);
    };

    // Get URL query parameter
    const getUrlParameter = (name) => {
        const params = new URLSearchParams(window.location.search);
        return params.get(name) || '';
    };

    // Smooth scroll to element
    const scrollTo = (element) => {
        element?.scrollIntoView({ behavior: 'smooth' });
    };

    return {
        init,
        addOverlay,
        removeOverlay,
        getUrlParameter
    };
})();


// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', App.init);